import React, { useEffect, useState } from "react";
import Header from "../../Header";
import PolicyholderReview from "../../components/PolicyholderReview";
import { useDispatch, useSelector } from "react-redux";
import {
  documentsSearch,
  fetchContributionPlanByID,
  fetchPolicyHolderInfo,
  loadingUser,
  loginCnss,
  printPolicyholderReport,
} from "../../action";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Box, Button, Grid, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DocumentViewDialog from "../../components/DocumentViewDailog/DocumentView";
import { GedToken } from "../../utils/constant";

const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));
function PolicyholderDetailsPage() {
  const [documentView, setDocumentView] = useState(false);
  const [blobUrl, setBlobURL] = useState();
  const navigate = (path) => {
    // Your custom navigation logic here
    console.log("Navigating to:", path);
    // For example, you might use window.location.href to change the URL
    window.location.href = path;
  };
  const dispatch = useDispatch();
  const handleNavigation = (path) => {
    navigate(path);
  };
  const userData = useSelector((state) => state.profileReducer);
  const token = localStorage.getItem("token");
  const policyholderUserData =
    userData?.policyholderUserResponseData?.[0]?.policyHolder;
  const { t } = useTranslation();
  useEffect(() => {
    if (userData?.currentUserResponseData?.id) {
      dispatch(fetchPolicyHolderInfo(userData?.currentUserResponseData?.id));
    }
    dispatch(loadingUser(token));

    if (policyholderUserData?.id) {
      dispatch(fetchContributionPlanByID(policyholderUserData?.id));
      dispatch(documentsSearch(policyholderUserData));
      // unwrapJSONFields(policyholderUserData);
    }
  }, [userData?.currentUserResponseData?.id, policyholderUserData]);

  useEffect(() => {
    loginCnss();
  }, []);

  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();
    if (contentType === "pdf") {
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }

    printWindow.document.close();
    // printWindow.print();
  };
  const downloadRegistration = async () => {
    try {
      // Make the API call
      const response = await dispatch(
        printPolicyholderReport(policyholderUserData?.id)
      );
      if (!!response?.sentNotification.success) {
        const base64Data = response?.sentNotification?.data;
        const contentType = "pdf";
        displayPrintWindow(base64Data, contentType);
      } else {
        console.error("Failed to download registration:", response.success);
      }
    } catch (error) {
      // Handle error if the API call fails
      console.error("Error downloading registration:", error.message);
    }
  };

  const handleDocumnetView = (document) => {
    console.log("document", document);
    const apiUrl = `${process.env.REACT_APP_GED_URL}/documents/get`;
    const headers = {
      Authorization: `Bearer ${GedToken}`,
      "Content-Type": "application/json",
    };

    fetch(`${apiUrl}?documentUuid=${document?.documentId}`, {
      method: "POST",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const pdfUrl = URL.createObjectURL(blob);
        setBlobURL(pdfUrl);
        setDocumentView(true);
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };
  return (
    <Grid >
      <Header
        children={
          <Content>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h5"
                sx={{
                  display: "flex",
                  fontWeight: "bold",
                }}
              >
                {t("policyholderDetailsTitle")}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => downloadRegistration()}
                // startIcon={<FileDownloadOutlinedIcon />}
              >
                {t("registrationCertificate")}
              </Button>
            </Box>
            <PolicyholderReview
              phId={policyholderUserData}
              handleDocumnetView={handleDocumnetView}
            />
            {documentView && (
              <DocumentViewDialog
                blobUrl={blobUrl}
                documentView={documentView}
                setDocumentView={setDocumentView}
              />
            )}
          </Content>
        }
      />
    </Grid>
  );
}

export default PolicyholderDetailsPage;
